import { render, staticRenderFns } from "./widget_ops_events.vue?vue&type=template&id=88e7ac54&"
import script from "./widget_ops_events.vue?vue&type=script&lang=js&"
export * from "./widget_ops_events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports